import { render, staticRenderFns } from "./Lender.vue?vue&type=template&id=ca0abb56&"
import script from "./Lender.vue?vue&type=script&lang=js&"
export * from "./Lender.vue?vue&type=script&lang=js&"
import style0 from "./Lender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports